import type { ReportsRepository } from './repository';
import type { ReportKind, ReportQuery, ReportResult } from './types';

export interface MockReportQuery extends ReportQuery {
  readonly kind: ReportKind;
}

export class MockReportsRepository implements ReportsRepository {
  readonly queries: MockReportQuery[] = [];

  run(kind: ReportKind, query: ReportQuery, signal: AbortSignal): Promise<ReportResult> {
    if (signal.aborted) throw new DOMException('Report request aborted', 'AbortError');
    this.queries.push({ kind, ...query, filters: { ...query.filters } });
    return Promise.resolve(mockReportResult(kind, query));
  }
}

function mockReportResult(kind: ReportKind, query: ReportQuery): ReportResult {
  const now = '2026-07-23T10:00:00.123456+07:00';
  const currency = query.filters.currency.trim().toUpperCase() || 'THB';
  return {
    rows: [
      {
        id: '00000000-0000-4000-8000-000000000001',
        occurredAt: now,
        partnerId: '00000000-0000-4000-8000-000000000002',
        agentId: '00000000-0000-4000-8000-000000000003',
        memberId: '00000000-0000-4000-8000-000000000004',
        uplineMemberId: null,
        gameTypeId: null,
        gameId: null,
        transactionId: '00000000-0000-4000-8000-000000000005',
        walletId: null,
        withdrawalId: null,
        currencyCode: currency,
        status: 'CALCULATED',
        code: kind.toUpperCase().replaceAll('-', '_'),
        name: 'Mock report row',
        username: 'affiliate.mock',
        partnerUserId: 'partner-user-mock',
        dimensions: { reportKind: kind },
        metrics: { amount: '12345.678901', count: 42 },
      },
    ],
    totals: [
      {
        currencyCode: currency,
        playAmount: '12345.678901',
        agentCommissionGross: '100.000000',
        affiliateCommissionGross: '200.000000',
        commissionReversals: '-10.000000',
        commissionAdjustments: '5.000000',
        netCommission: '295.000000',
        walletAvailable: '1000.000000',
        walletReserved: '25.000000',
        withdrawalRequested: '50.000000',
        withdrawalReserved: '25.000000',
        withdrawalCompleted: '20.000000',
        withdrawalReleased: '3.000000',
        withdrawalUnknown: '2.000000',
      },
    ],
    meta: {
      snapshotId: '00000000-0000-4000-8000-000000000006',
      reportingAsOf: now,
      refreshedAt: now,
      stale: false,
      timezone: query.filters.timezone || 'Asia/Bangkok',
      timeBasis: query.filters.timeBasis || 'PLAY_AT',
      normalizedFilters: { ...query.filters },
    },
    nextCursor: null,
    requestId: 'mock-report-request',
  };
}
